// extracted by mini-css-extract-plugin
export var ccLogo = "Footer-module--ccLogo--73498";
export var content = "Footer-module--content--edf3d";
export var root = "Footer-module--root--93a12";